import { Plane } from "lucide-react";
import { FLEETS } from "../../lib/constants";

export default function Capabilities() {
  return (
    <section
      id="capabilities"
      data-testid="capabilities-section"
      className="relative bg-white py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="mb-14">
          <h2 className="font-display font-bold text-[#0B1D3A] text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight max-w-3xl">
            Aircrafts
            <br />
            <span className="text-[#C9A961]">We Support.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {FLEETS.map((fleet) => (
            <div
              key={fleet.manufacturer}
              data-testid={`capability-${fleet.manufacturer.replace(/\s+/g, "-").toLowerCase()}`}
              className="bg-[#F8F9FA] border border-[#E5E7EB] rounded-sm overflow-hidden hover:border-[#1E3A5F] hover:-translate-y-1 transition-all duration-300"
            >
              <div className="bg-[#0B1D3A] text-white p-6 flex items-center justify-between border-b-2 border-[#C9A961]">
                <div>
                  <p className="text-[11px] uppercase tracking-[0.22em] text-[#C9A961] font-semibold mb-1">
                    Manufacturer
                  </p>
                  <h3 className="font-display font-bold text-xl">
                    {fleet.manufacturer}
                  </h3>
                </div>
                <div className="w-12 h-12 border border-[#C9A961]/40 bg-[#C9A961]/10 flex items-center justify-center rounded-sm">
                  <Plane className="w-5 h-5 text-[#C9A961]" />
                </div>
              </div>

              <div className="p-6 space-y-6">
                {fleet.families.map((fam) => (
                  <div key={fam.title}>
                    <p className="font-display font-semibold text-[#0B1D3A] text-sm mb-3 tracking-tight">
                      {fam.title}
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {fam.models.map((m) => (
                        <span
                          key={m}
                          className="inline-block font-mono text-[12px] tracking-tight bg-white border border-[#E5E7EB] text-[#111827] px-2.5 py-1 rounded-sm hover:border-[#C9A961] hover:text-[#0B1D3A] transition-colors"
                        >
                          {m}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
